export const computeRepeatableNumberFromUUID = (id: Maybe<string>) => {
  // the first segment of the UUID
  return parseInt(id?.split('-')[0] || '0', 16);
};
